import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";

interface ArticleJsonLdProps {
  title: string;
  description: string;
  publishedDate: string;
  modifiedDate: string;
  inLanguage?: string;
}

export function ArticleJsonLd({ title, description, publishedDate, modifiedDate, inLanguage = "en" }: ArticleJsonLdProps) {
  const location = useLocation();

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "article-jsonld";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Article",
      headline: title,
      description,
      datePublished: publishedDate,
      dateModified: modifiedDate,
      author: { "@type": "Organization", name: "System Atlas", url: "https://systematlas.fr" },
      publisher: { "@type": "Organization", name: "System Atlas", url: "https://systematlas.fr" },
      mainEntityOfPage: `https://systematlas.fr${location.pathname}`,
      inLanguage,
    });

    const existing = document.getElementById("article-jsonld");
    if (existing) existing.remove();
    document.head.appendChild(script);

    return () => { script.remove(); };
  }, [title, description, publishedDate, modifiedDate, location.pathname]);

  return null;
}
